"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _variables = _interopRequireDefault(require("../utils/variables"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Component for showing Loading State
 * @param {string} color Dot Color to be passed : Optional Parameter
 * @returns An jsx element consisting of a React Skeleton for loading state
 */
var BubbleDotLoader = function BubbleDotLoader(props) {
  var color = (props === null || props === void 0 ? void 0 : props.color) || _variables["default"].primaryTheme;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "bouncing-loader"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: color
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: color
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: color
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: color
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: color
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: color
    }
  }));
};

BubbleDotLoader.propTypes = {
  color: _propTypes["default"].string
};
BubbleDotLoader.defaultProps = {
  color: "#43c6ac"
};
var _default = BubbleDotLoader;
exports["default"] = _default;